import { ContactMeFirebaseRepository } from "../../core/repositories/contact-me/ContactMeFirebaseRepository";
import { IContactMeRepository } from "../../core/repositories/contact-me/IContactMeRepository";
import Cubit from "../../core/utils/cubit";
import { IProcessingService, ProcessingService } from "../processing-service/ProcessingService";
import { ContactMeState } from "./contactMeStates";

export abstract class IContactMeBloc extends Cubit<ContactMeState> {
    abstract getLastContactMe: () => Promise<ContactMeState>;
}

export class ContactMeBloc extends IContactMeBloc {
    private contactMeRepository: IContactMeRepository = new ContactMeFirebaseRepository();
    private processingService: IProcessingService = ProcessingService.getInstance();
    constructor() {
        super({ state: "LOADING" });
        this.getLastContactMe();
    }
    getLastContactMe: () => Promise<ContactMeState> = async (): Promise<ContactMeState> => {
        try {
            this.processingService.startProcessing();
            const latestContactMe = await this.contactMeRepository.getLatestContactMe();
            if (latestContactMe === undefined) {
                throw Error("NO CONTACT ME DOCUMENT IS FOUND");
            }
            this.emit({state: "LOADED", data: latestContactMe});
            this.processingService.stopProcessing();
        } catch (error) {
            this.emit({state: "ERROR", error});
        }
        return this.state;
    }

}